<p-chart type="doughnut" width="108px" [data]="schemaData" [options]="options" [plugins]="plugins"></p-chart>
